import React from "react";

/**
 * Con dấu giáp lai pháp nhân cho các trang hợp đồng từ trang 2 trở đi
 * - Hiển thị ở mép ngoài cùng bên phải của trang giấy A4 (chuẩn văn thư bán nguyệt mép giấy).
 * - Sử dụng con dấu thật của công ty (data.seal_image / data.sealImage / customStamp / company.stampImage).
 */
export default function GiapLaiSeal({ company, customStamp, pageNumber, data, visible = true }) {
  const sealImg =
    customStamp ||
    data?.seal_image ||
    data?.sealImage ||
    company?.stampImage ||
    null;

  if (!visible || !sealImg) {
    return null;
  }

  return (
    <div
      className="contract-giap-lai-stamp"
      style={{
        position: "absolute",
        right: -32,
        top: "48%",
        transform: "translateY(-50%) rotate(-6deg)",
        width: 84,
        height: 84,
        zIndex: 25,
        pointerEvents: "none",
        opacity: 0.92,
        userSelect: "none",
        display: "block",
      }}
      title={`Dấu giáp lai trang ${pageNumber || ""}`}
    >
      <img
        src={sealImg}
        alt="Dấu giáp lai"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
}

